import { getReviews } from 'services/reviews/getReviews';
import {
  hideLoader,
  showErrorResponseModal,
  showLoader,
} from 'store/actions/commons';
import {
  FETCH_REVIEWS,
  FETCH_REVIEWS_SUCCESS,
  FETCH_REVIEWS_FAILED,
  SET_REVIEWS_PARAMS,
  SET_REVIEWS_STATS,
  CLEAN_LIST_OF_REVIEWS,
} from './type';

export const fetchReviewsSuccess = (payload) => ({
  type: FETCH_REVIEWS_SUCCESS,
  payload,
});

export const fetchReviewsFailed = (payload) => ({
  type: FETCH_REVIEWS_FAILED,
  payload,
});

export const fetchReviews =
  ({ withLoader = true, ...payload } = {}) =>
  (dispatch, state) => {
    if (withLoader) dispatch(showLoader());

    dispatch({ type: FETCH_REVIEWS, payload });

    const { incrementalList = false } = payload;

    const { params = {} } = state.reviews.listOfReviews;

    getReviews(params)
      .then(([reviews, stats]) => {
        dispatch(fetchReviewsSuccess({ ...reviews, stats, incrementalList }));
      })
      .catch((error) => {
        console.error('error', error);
        if (withLoader) dispatch(showErrorResponseModal(error));
        dispatch(fetchReviewsFailed(error));
      })
      .finally(() => {
        if (withLoader) dispatch(hideLoader());
      });
  };

export const setReviewsParams = (payload) => ({
  type: SET_REVIEWS_PARAMS,
  payload,
});

export const setReviewsStats = (payload) => ({
  type: SET_REVIEWS_STATS,
  payload,
});

export const cleanListOfReviews = (payload) => ({
  type: CLEAN_LIST_OF_REVIEWS,
  payload,
});
